export default __webpack_public_path__ + "static/media/MO.ef8c319c.svg";